<div class="flex flex-column align-items-start gap-3 align-self-stretch pb-4">
  <div class="flex flex-column gap-2">
    <label id="status-label">{{ i18n.i18nLng()['STATE'] }}</label>
    <p-select-button [options]="stateOptions"
                     [(ngModel)]="paymentData.status"
                     [allowEmpty]="false"
                     optionLabel="label"
                     optionValue="value"
                     aria-labelledby="status-label"
                     (onChange)="paymentStatusChanged($event)">
    </p-select-button>
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="payment-category">{{ i18n.i18nLng()['PAYMENTMETHOD'] }}</label>
    <input pInputText id="payment-category" [(ngModel)]="paymentMethod" [disabled]="true" pSize="large"/>
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="payment-method-name">{{ i18n.i18nLng()['PAYMENTMETHODDESC'] }}<sup class="sps-sup">*</sup></label>
    <input pInputText
           id="payment-method-name"
           maxlength="80"
           [(ngModel)]="paymentData.title"
           [required]="true"
           [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
           [ngClass]="paymentInvalidFlags.title ? 'ng-invalid ng-dirty' : null"
           [attr.aria-invalid]="paymentInvalidFlags.title"
           [attr.aria-describedby]="paymentInvalidFlags.title ? 'title-invalid-help' : null"
           pSize="large"/>
    @if (paymentInvalidFlags.title) {
      <small style="line-height: 1.5rem" class="text-error" role="alert" id="title-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
    }
  </div>
  @if ((customerGroup === CustomerGroup.SID) && paymentData.paymentMethod === PaymentMethodName.CREDITCARD) {
    <div class="flex align-items-center">
      <p-checkbox inputId="chargeback-card" [(ngModel)]="paymentData.isChargebackCard" [binary]="true" size="large"/>
      <label for="chargeback-card" class="ml-2 text-lg">{{ i18n.i18nLng()['CHARGEBACKCARD'] }}</label>
    </div>
  }
  @if (!refreshView) {
    @if (showSwitchLiveWarning) {
      <div class="flex">
        <p-message severity="warn" icon="pi pi-exclamation-triangle">
          {{ i18n.i18nLng()['SWITCHLIVEWARNING'] }}
        </p-message>
      </div>
    }
  }
  @if (paymentInvalidFlags.missingLiveData) {
    <p-message severity="warn" icon="pi pi-exclamation-triangle">
      {{ i18n.i18nLng()['MISSINGLIVEDATA'] }}
    </p-message>
  }
</div>
